<template>
  <!--  lxj
  *    2021/07/28

          <Detaillist
            :detaillist="detaillist"
            :data="data"
            @warningblock="warningblock"
          />
          
  *     详情组件
  *     传入 :detaillist=obj
  *     obj:{
    ///////详情显示  特殊函数需加上this.data
  *      column:[{
  *        label:'名称',
  *        prop:'显示字段名  eg:深层数据显示需填写 deep.deep.data   否则填写  data',
  *        show:'特殊显示隐藏 eg:data>1',
  *        formatter:()=>{ return  } //特殊函数显示
  *       }],

  ////////按钮下方区块 显示
        showcolumn:[{ 
            label: "合同申请",
            prop: "wfStatus",
            state: 0,     // state ：0  前面是否加上小圆点
            show:"pageData.wfStatus<2&&pageData.auditState == 0",
            //show 显示隐藏条件  需加上 pageData
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=wf_status",
            //业务字典
        }],
        //详情显示大小
        firstsblock:{
              formatter:()=>{ 
              return this.data.auditState >= "1" ? 23:19; 
              }
            },
            ///按钮下方区块显示大小
             sentersblock:{
               formatter:()=>{
                 return  this.data.auditState >= "1" ? 1:5;
                }
             },
             //详情第一 row
               firstrow: {
                formatter: () => {
                  return {
                    width: "30%",
                  };
                },
              },
              // //详情第二 row
        secondrow: {
          formatter: () => {
            return {
              width: "40%",
            };
          },
        },
        // //详情第三 row
        thirdrow: {
          formatter: () => {
            return {
              width: "30%",
            };
          },
        },
  *      }
  *
  *
  *
  *
      qja
 -->
  <div>
    <el-row type="flex" class="row-bg" justify="space-between">
      <el-col :span="firstsblock">
        <div class="flexdivs">
          <div
            :class="[
              'rowcol_div',
              
            ]"
            v-for="(item, index) in detailonerow"
            :key="index"
            :style="item.style ? item.style : 'width:33%'"
          >
            <div
              v-if="item.show != undefined ? item.show : true"
              class="flex_prop_item"
            >
              <label class="fontcolor">{{ item.label }}:</label>
              <slot v-if="item.slot" :name="detaillist.column[index].prop"></slot>
              <span v-else class="prop_div">
                <template v-if="item.url">
                  <!-- <el-button
                    @click="toDetail(item.url)"
                    type="text"
                    size="small"
                  > -->
                    <span class="prop_button" @click="toDetail(item.url)">
                        {{ item.proptext ? item.proptext : item.prop }}
                    </span>
                </template>
                <template v-else>
                  {{ item.proptext ? item.proptext : item.prop
                  }}{{ item.append ? item.append : "" }}
                </template>
              </span>
              
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="sentersblock">
        <div class="stateblocks">
          <div
            class="stateTop"
            v-for="(item, index) in datashowcolums"
            :key="index"
          >
            <!-- {{item.show}}{{data.auditState}}{{data.wfStatus}} -->
            <div v-show="item.show != undefined ? item.show : true">
              <span> {{ item.label }}</span>
              <div :class="['stateTopdiv', 'color_' + item.prop]">
                {{ item.proptext ? item.proptext : item.prop }}
                <span
                  v-if="
                    data.auditLog != '' && data.auditState == 0 && item.auditlog
                  "
                >
                  <i class="el-icon-warning-outline" @click="warningblock"></i>
                </span>
                <span
                  v-if="
                    data.terminateLog != '' && data.auditState == 2 && item.terminateLog
                  "
                >
                  <i class="el-icon-warning-outline" @click="terminateblock"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import * as api from "@/api/zd/xiangqin.js";
export default {
  data() {
    return {
      detailonerow: {},
      datashowcolums: {},
    };
  },
  props: { detaillist: Object, data: Object },
  mounted() {
    this.pagedatas();
    this.showcolumn();
  },
  computed: {
    // ...mapGetters(["permission"]),
    firstdiv() {
      return this.detaillist.firstrow.formatter();
    },
    seconddiv() {
      return this.detaillist.secondrow.formatter();
    },
    thirddiv() {
      return this.detaillist.thirdrow.formatter();
    },
    firstsblock() {
      return this.detaillist.firstsblock.formatter();
    },
    sentersblock() {
      return this.detaillist.sentersblock.formatter();
    },
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.pagedatas();
        this.showcolumn();
      },
    },
  },

  methods: {
    //详情内容
    pagedatas() {
      let newdatas = [];
      let pageData = this.data;
      // column

      if (this.detaillist.column.length > 0) {
        let onerows = this.detaillist.column;
        onerows.map((item) => {
          let dats = {
            ...item,
            prop: item.formatter
              ? item.formatter()
              : eval("pageData." + item.prop),
            proptext: item.dicUrl
              ? this.apitext(item.dicUrl, eval("pageData." + item.prop),item.dicMethod).then(
                  (res) => {
                    dats.proptext = res ? res : "-";
                  }
                )
              : undefined,
            url:
              item.url != undefined
                ? item.url + eval("pageData." + item.urlId)
                : undefined,
            style: item.show != undefined
                ? eval("pageData." + item.show)?item.style:'width:0'
                : item.style,
            append: item.append,
            show:
              item.show != undefined
                ? eval("pageData." + item.show)
                : undefined,
          };
          return newdatas.push(dats);
        });

        this.detailonerow = newdatas;
      }
    },
    // 按钮下方详情块
    showcolumn() {
      let pageData = this.data;
      if (this.detaillist.showcolumn == undefined) return;
      let showcolumns = this.detaillist.showcolumn;
      let newdatas = showcolumns.map((item) => {
        let data = {};
        if (item.dicUrl) {
          
          this.apitext(item.dicUrl, eval("pageData." + item.prop)).then(
            (res) => {
              data.proptext = res;
            }
          );
        }
        data = {
          ...item,
          prop: eval("pageData." + item.prop),
          proptext: item.dicUrl
            ? this.apitext(item.dicUrl, eval("pageData." + item.prop)).then(
                (res) => {
                  data.proptext = res;
                }
              )
            : undefined,
          show: item.show ? eval(item.show) : undefined,
        };

        return data;
      });

      this.$nextTick(() => {
        this.datashowcolums = newdatas;
      });
    },
    apitext(dicUrl, prop,method) {
      
      return new Promise((resolve) => {
        api.getDIC(dicUrl,method).then((res) => {
          let selfData = res.data.data;
          let thisData = selfData.filter((item) => {
            return parseFloat(item.dictKey) == parseFloat(prop);
          });
          let valueData = thisData.length > 0 ? thisData[0].dictValue : "";

          resolve(valueData);
        });
      });
    },
    warningblock() {
      this.$emit("warningblock");
    },
    terminateblock(){
       this.$emit("terminateblock");
    },
    //跳转
    toDetail(url) {
      console.log(url);
      this.$router.push({ path: url });
    },
  },
};
</script>

<style lang="scss" scoped>
.flexdivs {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.rowcol_div {
  display: inline-block;
  padding: 8px 0;
  .flex_prop_item {
    display: flex;
    .fontcolor {
      color: #999999;
    }
    .prop_div {
      flex: 1;
      padding: 0 15px;
      .prop_button {
        color: #409EFF;
        cursor: pointer;
      }
      
     
    }
  }
}
.first_div {
  width: 30%;
}
.second_div {
  width: 35%;
}
.third_div {
  width: 35%;
}
.stateblocks {
  display: flex;
  flex-direction: row;
  width: 100%;
  flex-wrap: wrap;
  justify-content: flex-end;
}
.stateTop {
  color: rgb(187, 185, 185);
  // text-indent: 12px;
  text-align: right;
  padding: 5px 3px;
}
.stateTop .stateTopdiv {
  color: #666666;
  font-size: 20px;
}
// .stateTop:nth-of-type(1){
//      flex: 5;
//      text-align: left;
// }
.stateTopdiv::before {
  content: "";
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 5px;
}
.color_0::before {
  background: #fec03d;
}
.color_1::before {
  background: #409eff;
}
.color_2::before {
  background: #51d351;
}
.color_3::before {
  background: #51d351;
}
.color_4::before {
  background: #F56C6C;
}
.warningblock {
  cursor: pointer;
  color: rgb(197, 192, 192);
}
</style>